import { useMemo } from "react";
import { View } from "react-native";
import ProfilePictureRowUser from "./components/ProfilePictureRowUser";
import { ProfilePictureRowProps } from "./types";

const SIZE_PERCENTAGE = 0.5;
const ProfilePictureRow = ({
	users,
	containerStyle,
	size = 32,
	numProfilePictures,
}: ProfilePictureRowProps) => {
	const usableUsers = useMemo(
		() => users.filter((user) => user).slice(0, numProfilePictures ?? Infinity),
		[users, numProfilePictures],
	);

	return (
		<View
			style={[
				containerStyle,
				{
					flexDirection: "row",
					width:
						usableUsers.length > 0
							? size + Math.max((usableUsers.length - 1) * size * SIZE_PERCENTAGE, 0)
							: 0,
					height: size,
					// Shouldn't be necessary, but just in case
					overflow: "hidden",
				},
			]}
		>
			{usableUsers.map((user, i) => (
				<ProfilePictureRowUser
					key={typeof user === "string" ? user : (user?.userId ?? i)}
					user={user}
					size={size}
					style={{
						position: "absolute",
						left: i * size * SIZE_PERCENTAGE,
						zIndex: usableUsers.length - i,
					}}
				/>
			))}
		</View>
	);
};
export default ProfilePictureRow;
